<ngx-loading
  class="loading"
  [show]="isVisible"
  [config]="{
    animationType: ngxLoadingAnimationTypes.wanderingCubes,
    primaryColour: primaryColour,
    secondaryColour: secondaryColour,
    backdropBorderRadius: '3px'
  }">
</ngx-loading>